import React from 'react'

export default function BoardForums({ color }: { color: string }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2693_1170)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.674805 0.5625H23.7152V3.72605H3.81585V27.3694H0.674805V0.5625Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M26.8603 31.4375H3.81543V3.72607H26.8603V18.7518" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M31.3293 18.7518H17.1406V31.4375H31.3293V18.7518Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M31.3293 29.4125H17.1406V31.4375H31.3293V29.4125Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M22.5049 18.7518H25.9654V23.6614L24.2284 22.0864L22.5049 23.6614V18.7518Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.15039 7.5061H23.5261" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.15039 10.8632H21.5686" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.15039 14.2247H23.5261" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.15039 17.5818H10.962" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.15039 20.9388H14.7735" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.15039 24.3004H14.7735" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.15039 27.6575H10.962" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2693_1170">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}
